import type { AsideRoomItemProps } from './AsideRoomItem'

export const joins: AsideRoomItemProps[] = [
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    status: 'complete',
    title: 'Plinko',
    username: '@pos69',
    userQuantity: 3,
  },
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    status: 'onGoing',
    title: 'Wheel',
    username: '@pos69',
    userQuantity: 3,
  },
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    status: 'onGoing',
    title: 'Crash',
    username: '@pos69',
    userQuantity: 3,
  },
]

export const available: AsideRoomItemProps[] = [
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    time: '3:48',
    title: 'Crash',
    username: '@pos69',
    userQuantity: 3,
  },
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    time: '3:48',
    title: 'Wheel',
    username: '@pos69',
    userQuantity: 3,
  },
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    time: '3:48',
    title: 'Keno',
    username: '@pos69',
    userQuantity: 3,
  },
  {
    imgUrl: '/assets/room.png',
    money: 20445,
    time: '3:48',
    title: 'Coinflip',
    username: '@pos69',
    userQuantity: 3,
  },
]
